var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { memoize } from '../../../../utils/mobx/decorators/memoize';
import { MobxPrepone } from '../../../../utils/mobx/decorators/MobxPrepone';
import { traitRegistry } from '../../../../registry/Registry';
export class AspectLocal {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get aspect() {
        return this.parent;
    }
    get persistentAspect() {
        return this.aspect.persistentAspect;
    }
    get traits() {
        return this.persistentAspect.traits;
    }
    get traitsOf() {
        return new Proxy(this, {
            get: (x, traitKey) => {
                return this.traits.filter((trait) => trait.key === traitKey);
            },
        });
    }
    /*
    @memoize
    get baseTraitOf(): AspectTraitOfProxy {
      return (new Proxy(this, {
        get: (x, traitKey: keyof TraitRegistryObject) => {
          const baseTrait = this.aspect.traits.find(trait => trait.key === traitKey && !trait.condition);
          if (baseTrait) return baseTrait;
          return this.aspect.traits.find(trait => trait.key === traitKey);
        }
      }) as any) as AspectTraitOfProxy;
    }
  */
    get traitOf() {
        return new Proxy(this, {
            get: (x, traitKey) => {
                return this.traits.find((trait) => trait.key === traitKey);
            },
        });
    }
    get lowestTraitOf() {
        return new Proxy(this, {
            get: (x, traitKey) => {
                return this.traits
                    .concat()
                    .reverse()
                    .find((trait) => trait.key === traitKey);
            },
        });
    }
    get valueOf() {
        return new Proxy(this, {
            get: (x, traitKey) => {
                const trait = this.traits.find((trait) => trait.key === traitKey);
                if (trait && typeof trait.value !== 'undefined') {
                    return trait.value;
                }
                return traitRegistry.registry_object[traitKey] && traitRegistry.registry_object[traitKey].default;
            },
            set: (x, key, value) => {
                const trait = this.traits.find((trait) => trait.key === key);
                /* 21.11.2018 Bug cleanup, nur temporär aktivieren !
                if (runtime.runtimePermissions.hasEditFunctionality) {
                  const toDelete = this.aspect.persistentAspect.traits.filter(
                    t => t !== trait && t.key === key && ['imageWidth', 'imageHeight', 'textBasis'].includes(t.key)
                  );
                  if (toDelete.length > 0) {
                    runtime.runtimeScheduler.addToNextStateChange(() => {
                      toDelete.forEach(trait => trait.traitEdit.remove());
                    });
                  }
                }
                 */
                if (trait) {
                    if (typeof value === 'undefined') {
                        trait.traitEdit.remove();
                    }
                    else {
                        trait.value = value;
                    }
                }
                else {
                    this.persistentAspect.aspectCreateTrait.addNewBySerialized({ key, value });
                }
                return true;
            },
        });
    }
    get valuesOf() {
        return new Proxy(this, {
            get: (x, traitKey) => {
                return this.traitsOf[traitKey].map((trait) => trait.value);
            },
        });
    }
    get ensuredTraitOf() {
        return new Proxy(this, {
            get: (x, key) => {
                if (this.persistentAspect.local.has[key]) {
                    return this.traitOf[key];
                }
                return MobxPrepone.provideInstant({
                    owner: this,
                    instantFactory: () => this.persistentAspect.aspectCreateTrait.createNewTraitBySerialized({ key }),
                    modifyState: (trait) => this.persistentAspect.aspectCreateTrait.addTraitToEnd(trait),
                    context: key,
                });
            },
        });
    }
    get ensuredLowestTraitOf() {
        return new Proxy(this, {
            get: (x, key) => {
                if (this.persistentAspect.local.has[key]) {
                    return this.lowestTraitOf[key];
                }
                return MobxPrepone.provideInstant({
                    owner: this,
                    instantFactory: () => this.persistentAspect.aspectCreateTrait.createNewTraitBySerialized({ key }),
                    modifyState: (trait) => this.persistentAspect.aspectCreateTrait.addTraitToEnd(trait),
                    context: key,
                });
            },
        });
    }
    get has() {
        return new Proxy(this, {
            get: (x, traitKey) => {
                return !!this.traitOf[traitKey];
            },
        });
    }
    get removeAll() {
        return new Proxy(this, {
            get: (x, traitKey) => {
                return () => x.traitsOf[traitKey].forEach((trait) => trait.traitEdit.remove());
            },
        });
    }
}
__decorate([
    memoize
], AspectLocal.prototype, "traitsOf", null);
__decorate([
    memoize
], AspectLocal.prototype, "traitOf", null);
__decorate([
    memoize
], AspectLocal.prototype, "lowestTraitOf", null);
__decorate([
    memoize
], AspectLocal.prototype, "valueOf", null);
__decorate([
    memoize
], AspectLocal.prototype, "valuesOf", null);
__decorate([
    memoize
], AspectLocal.prototype, "ensuredTraitOf", null);
__decorate([
    memoize
], AspectLocal.prototype, "ensuredLowestTraitOf", null);
__decorate([
    memoize
], AspectLocal.prototype, "has", null);
__decorate([
    memoize
], AspectLocal.prototype, "removeAll", null);
